<template>
  <section :class="$style.qr">
    <img
      v-if="!hasError"
      :src="qrUrl"
      alt="QRimage"
      :class="$style.qr__image"
      @error="onImageError"
    />
    <p v-else :class="$style.qr__error">QR コードの読み込みに失敗しました</p>
    <!-- Avoid window.fetch() here: OAuth2 proxy redirects CORS preflight, breaking fetch-based downloads.
         The download attr may be ignored cross-origin; target="_blank" prevents navigating away. -->
    <a
      :href="qrUrl"
      :class="$style.qr__button"
      :download="filename"
      target="_blank"
      rel="noopener"
      @click="onClickDownload"
    >
      ダウンロード
    </a>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { getAPIBaseURL, getShadowPlannerChatQRURL } from '@/config'
import { useLogger } from '@/logger/logger'

const props = defineProps<{
  plannerId: number
}>()

const filename = computed<string>(() => {
  return `okane-kenko_planner_qr-${props.plannerId}.png`
})

const qrUrl = computed<string>(() => {
  const qrBase = getAPIBaseURL('qr')
  const destinationUrl = getShadowPlannerChatQRURL(props.plannerId)
  const params = new URLSearchParams({ m: destinationUrl })
  return `${qrBase}/?${params}`
})

const hasError = ref(false)

const logger = useLogger()

const onImageError = () => {
  hasError.value = true
  console.warn('Failed to load QR image', {
    plannerId: props.plannerId,
    url: qrUrl.value,
  })
}

const onClickDownload = async () => {
  logger.ltlPeople.event.downloadQr(logger.buildMeta())
}
</script>

<style lang="scss" module>
.qr {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__image {
    display: block;
    height: 80px;
    width: 80px;
  }

  &__button {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }

  &__error {
    margin-top: 16px;
    font-size: 12px;
    color: #e53e3e;
  }
}
</style>
